import request from '@app/utils/apiRequest';

export const requestSaveJob = (data) => request.post(`job/save`, data)


export const requestGetJobList = (params) => request.get(`job/list`, {params: params});
export const requestGetJob = (params) => request.get(`job/detail`, {params: params});

export const requestGetJobHideUser= (params) => request.get(`job/detail/hide-user-list`, {params: params})
export const requestGetJobBasicInfo= (params) => request.get(`job/detail/basic-info`, {params: params})
export const requestGetJobCategoryInfo= (params) => request.get(`job/detail/category-info`, {params: params})
export const requestGetJobRequirementInfo= (params) => request.get(`job/detail/requirement-info`, {params: params})
export const requestGetJobOtherInfo= (params) => request.get(`job/detail/other-info`, {params: params})

export const requestGetJobDescriptionInfo= (params) => request.get(`job/detail/jd-info`, {params: params})

export const requestUploadJDFiles = (data) => request.post(`job/detail/upload-jd-files`, data)

export const requestDownloadJDFile = async (params) => {
    const res = await request.get(`/job/detail/download-jd-file`, {params: params, responseType: 'blob'});
    if (res) {
        const file = new Blob(
            [res],
            {type: 'application/pdf'});
        return URL.createObjectURL(file)
    }

    return ""
};

export const requestDeleteJDFile = (data) => request.delete(`job/detail/delete-jd-file`, {data: data})

// Run job APIs
export const requestStartRunJob = (data) => request.post(`job/run-job/start`, data)
export const requestGetRunJobList = (params) => request.get(`job/run-job/list`, {params: params})
export const requestSaveRunJob = (data) => request.post(`job/run-job/save`, data)
export const requestSendEmailInviteJob = (data) => request.post(`job/run-job/send-mail-invite-job`, data)

export const requestRemoveCandidatesOutTabs = (data) => request.post(`job/run-job/remove-candidates-out-tabs`, data)
export const requestMoveCandidatesToTab = (data) => request.post(`job/run-job/move-candidates-to-tab`, data)
export const requestUpdateCandidatesInSendMails = (data) => request.post(`job/run-job/update-candidates-in-send-mails`, data)
